<ng-container *ngFor="let service of services">
  <a
    [href]="service.url"
    type="button"
    mat-icon-button
  >
    <mat-icon [svgIcon]="service.type"></mat-icon>
  </a>
</ng-container>
